class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
  
      this.input = this.querySelector('input[type="search"]');
      this.category_select = this.querySelector('select#category');
      this.brand_select = this.querySelector('select#brand');
      this.predictiveSearchResults = this.querySelector('#predictive-search');
      this.submit = this.querySelector('input[type="submit"]')
  
      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));

      this.category_select.addEventListener('change', this.debounce((event) => {
        this.querySelector('select#category').style.color = '#000';
        this.onChange(event);
      }, 300).bind(this));

      this.brand_select.addEventListener('change', this.debounce((event) => {
        this.querySelector('select#brand').style.color = '#000';
        this.onChange(event);
      }, 300).bind(this));
    
      this.submit.addEventListener('click', function(e){
        this.generationValue(e)
      }.bind(this))
    }
    
    generationValue(e){
      e.preventDefault()
      let searchTerm = this.input.value.trim();
      if (this.category_select.value !== '' && this.brand_select.value !== '') {
        searchTerm = searchTerm + `* tag:${this.category_select.value}+${this.brand_select.value}`;
      } else if (this.category_select.value !== '' && this.brand_select.value == '') {
          searchTerm = searchTerm + `* tag:${this.category_select.value}`;
      } else if (this.category_select.value == '' && this.brand_select.value !== '') {
          searchTerm = searchTerm + `* tag:${this.brand_select.value}`;
      } else {
          searchTerm = searchTerm;
      }
      let searchInput = document.querySelector('.search-input__wrapper input[type="search"]')
      searchInput.style.opacity = 0
      searchInput.value = searchTerm
      let form = document.querySelector('.live-search__wrapper form')
      form.submit()
    }

    onChange() {
      let path = (window.location.pathname).split('/')
      let template 
      for (let i = 0; i < path.length; i++) {
        if (path[i] == 'search') {
          template = 'search'
        }
      }
      if (template != 'search') {
        
      
      let searchTerm = this.input.value.trim();
  
        if (this.category_select.value == 'remove_filters' && this.brand_select.value == 'remove_filters') {
            document.querySelectorAll('predictive-search select#category option').forEach(category => category.style.display='initial');
            document.querySelector('predictive-search select#category option:first-child').selected = true;
            document.querySelector('predictive-search select#category').style = '#848484'
            document.querySelectorAll('predictive-search select#brand option').forEach(brand => brand.style.display='initial');
            document.querySelector('predictive-search select#brand option:first-child').selected = true;
            document.querySelector('predictive-search select#brand').style = '#848484'
        } else if (this.category_select.value == 'remove_filters') {
            document.querySelectorAll('predictive-search select#category option').forEach(category => category.style.display='initial') 
            document.querySelector('predictive-search select#category option:first-child').selected = true;
            document.querySelector('predictive-search select#category').style = '#848484'
        } else if (this.brand_select.value == 'remove_filters') {
            document.querySelectorAll('predictive-search select#brand option').forEach(brand => brand.style.display='initial')
            document.querySelector('predictive-search select#brand option:first-child').selected = true;
            document.querySelector('predictive-search select#brand').style = '#848484'
        }

      if (!searchTerm.length && this.category_select.value !== '' && this.brand_select.value !== '') {
        document.querySelectorAll('predictive-search select#category option').forEach(category => category.style.display='initial') 
        document.querySelectorAll('predictive-search select#brand option').forEach(brand => brand.style.display='initial')
        this.close();
      } else if (!searchTerm.length) {
        this.close();
      }

      if (this.category_select.value !== '' && this.brand_select.value !== '') {
          searchTerm = searchTerm + `* tag:${this.category_select.value}+${this.brand_select.value}`;
      } else if (this.category_select.value !== '' && this.brand_select.value == '') {
          searchTerm = searchTerm + `* tag:${this.category_select.value}`;
      } else if (this.category_select.value == '' && this.brand_select.value !== '') {
          searchTerm = searchTerm + `* tag:${this.brand_select.value}`;
      } else {
          searchTerm = searchTerm;
      }
      
      this.getSearchResults(searchTerm);
    }
    }



    getSearchResults(searchTerm) {
      
        fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=8&resources[fields]=title,tag&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
  
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
            
         /*  Category check */
          let category = document.querySelector('predictive-search select#category').value;
          let brand = document.querySelector('predictive-search select#brand').value;
          
          document.querySelectorAll('.predictive-search__list-item').forEach(elem => {
              if (elem.dataset.tags ) {

                if (category !== '' && brand !== '') {
                    if (elem.dataset.tags.includes(category) && elem.dataset.tags.includes(brand)) {
                        /* document.querySelectorAll('predictive-search select#brand option').forEach(brand => {
                            if (!elem.dataset.tags.includes(brand.value)) {
                                brand.style.display = 'none'
                            } else {
                                brand.style.display = 'initial'
                            }
                        })  */

                        document.querySelectorAll('predictive-search select#category option').forEach(category => {
                            if (!elem.dataset.tags.includes(category.value)) {
                                if (category.value !== 'remove_filters') {
                                    category.style.display = 'none'
                                }
                            } else {
                                category.style.display = 'initial'
                            }
                        }) 
                    }
                } else if (category !== '') {
                    if (elem.dataset.tags.includes(category)) {
                        /* document.querySelectorAll('predictive-search select#brand option').forEach(brand => {
                            if (!elem.dataset.tags.includes(brand.value)) {
                                brand.style.display = 'none'
                            } else {
                                brand.style.display = 'initial'
                            }
                        })  */
                    } 
                } else if (brand !== '') {
                    if (elem.dataset.tags.includes(brand)) {
                        document.querySelectorAll('predictive-search select#category option').forEach(category => {
                            if (!elem.dataset.tags.includes(category.value)) {
                                if (category.value !== 'remove_filters') {
                                    category.style.display = 'none'
                                }
                            } else {
                                category.style.display = 'initial'
                                console.log(category.value)
                            }
                        }) 
                    }
                }
              }
          })
          this.open();
        })
        .catch((error) => {
          this.close();
          throw error;
        });

      
      
        /* fetch('/products.json?limit=400')
      .then((response) => {
        return response.json();
      })
      .then((data) => {
          console.log(data)
        document.querySelector('div#predictive-search').innerHTML = '';
        data.products.forEach(elem => {
            if (elem.title.toLowerCase().includes(searchTerm.toLowerCase())) {
                if (document.querySelector('#category').value !== '') {
                    if (elem.tags.includes(document.querySelector('#category').value)) {
                        console.log(elem)
                        this.generateHTML(elem.images[0].src, elem.title)
                    }
                }
                
            }  
        })
      }); */
    }

    generateHTML(img, title) {
        document.querySelector('div#predictive-search').innerHTML += `<div class='wrapper'><img alt='${img}' src='${img}'/><span>${title}</span>  </div>`
    }
  
    open() {
      this.predictiveSearchResults.style.display = 'block';
    }
  
    close() {
        this.predictiveSearchResults.style.display = 'none';
    }
  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }
  
  customElements.define('predictive-search', PredictiveSearch);
  